/** @format */

export const getContentfulImage = (src: string, webp?: boolean, width?: number, height?: number) => {
  const hasQueryParams = webp || width || height;
  const queryParams = [webp && 'fm=webp', width && `w=${width}`, height && `h=${height}`].filter(n => n);

  return `https:${src}${hasQueryParams ? `?${queryParams.join('&')}` : ''}`;
};
